import { DialogActions, DialogContent } from '@bessemercws/components/bui';
import styled from '@emotion/styled';

export const StyledDialogContent = styled(DialogContent)`
  .UpdateEmail {
    margin-bottom: 1.5rem;
  }

  .CurrentEmail {
    margin-bottom: 0.5rem;
  }

  .Email {
    margin-bottom: 1.5rem;
  }
  .email-dialog--textfield-input {
    margin-bottom: 1.5rem;
  }

  .otc-input {
    margin-left: 4rem;
    margin-right: 4rem;
    margin-bottom: 1.5rem;
  }

  .otc-text {
    margin-left: 4rem;
    margin-right: 4rem;
  }
`;

export const StyledDialogActions = styled(DialogActions)`
  .dialog-button--different {
    text-transform: unset;
  }
  .dialog-button--validate {
    text-transform: unset;
  }
  .dialog-button--validate {
    text-transform: unset;
  }
`;
